/**
 * Page technique de recette « Page de référence des blocs » (mu-plugin WordPress
 * villerbx-block-reference) : publiée pour être buildée par Gatsby, mais jamais
 * visible des moteurs de recherche, du sitemap ni de la recherche interne.
 *
 * Source unique des slugs, lue par le template (noindex) ET par gatsby-config.js
 * (sitemap) : d'où le CommonJS. À garder identique à Villerbx_Block_Reference_Seeder::SLUGS
 * (www/backend/wp-content/mu-plugins/villerbx-block-reference/).
 * Un slug par langue : Polylang (version gratuite) interdit le même slug dans deux langues.
 */
const REFERENCE_PAGE_SLUGS = ['reference-blocs', 'blokken-referentie'];

// Vrai si le DERNIER segment du chemin est un slug de la page de référence
// (couvre /reference-blocs/, /nl/blokken-referentie/, /en/reference-blocs/…).
const isReferencePagePath = pathname => {
  if (!pathname || typeof pathname !== 'string') return false;
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 0 && REFERENCE_PAGE_SLUGS.includes(segments[segments.length - 1]);
};

// Motifs d'exclusion pour gatsby-plugin-sitemap : racine et préfixe de langue.
const referencePageSitemapExcludes = () =>
  REFERENCE_PAGE_SLUGS.reduce(
    (acc, slug) => acc.concat([`/${slug}`, `/${slug}/`, `/*/${slug}`, `/*/${slug}/`]),
    []
  );

module.exports = {
  REFERENCE_PAGE_SLUGS,
  isReferencePagePath,
  referencePageSitemapExcludes,
};
